import { render, staticRenderFns } from "./EquipmentCardSkeleton.vue?vue&type=template&id=4d423e20&"
import script from "./EquipmentCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./EquipmentCardSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports